import React from 'react';
import c from 'classnames';

import { useTranslation } from 'react-i18next';

import { SearchReset } from '@uncinc/react-searchkit';

import { useStats } from 'react-instantsearch';

import {
  Container,
  useDialog,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import Button from '../../Button';
import gtm from '../../../helpers/gtm';

export interface FacetsDialogProps {
  title?: string;
  openButtonLabel?: string;
  closeButtonLabel?: string;
  refineButtonLabel?: string;
  className?: string;
  children: React.ReactNode;
}

const FacetsDialog: React.FC<FacetsDialogProps> = (props) => {
  const {
    title,
    openButtonLabel,
    closeButtonLabel,
    refineButtonLabel,
    className,
    children,
  } = props;

  const { t } = useTranslation();
  const {
    dialogIsOpen,
    openDialog,
    closeDialog,
  } = useDialog();

  const classNames = c('FacetsDialog', className, {
    'FacetsDialog--is-open': dialogIsOpen,
  });

  const { nbHits } = useStats();

  return (
    <>
      <Button
        className="FacetsDialog__open-button"
        type="secondary"
        icon="filter_alt"
        onClick={() => {
          // @ts-expect-error
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          gtm.trackUserEvent('vacancies-opened-mobile-filters', true);

          openDialog();
        }}
      >
        {openButtonLabel || t('searchkit.vacancies.filter_dialog_open_button')}
      </Button>

      <div className={classNames}>
        <div className="FacetsDialog__wrapper">
          <Container className="h-100">
            <div className="row h-100">
              <div className="col-12 h-100">
                <div className="FacetsDialog__inner d-flex h-100">
                  <div className="FacetsDialog__header">
                    <h3>{title || t('searchkit.vacancies.filter_title')}</h3>

                    <Button
                      className="FacetsDialog__close-button"
                      type="link"
                      onClick={closeDialog}
                    >
                      {t('searchkit.vacancies.filter_dialog_close_button')}
                    </Button>
                  </div>

                  <div className="FacetsDialog__content">
                    {children}
                  </div>

                  <div className="FacetsDialog__footer mt-auto">
                    <Button onClick={closeDialog} variation="center">
                      {t('searchkit.vacancies.filter_dialog_submit_button', { count: nbHits })}
                    </Button>

                    <SearchReset
                      buttonText={t('searchkit.vacancies.filter_reset')}
                      resetSearch={false}
                      onClick={closeDialog}
                      // @ts-ignore
                      button={Button}
                      type="secondary"
                      variation="center"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>

        <div className="FacetsDialog__backdrop" />
      </div>
    </>
  );
};

export default FacetsDialog;
